export const CARD_MIN_HEIGHT = '425px'
